let date = '8/27/2024'; export default date;
